import SpriteSymbol from "../../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/_svg-sprite-loader@6.0.9@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "server",
  "use": "server-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"server\"><g fill-rule=\"evenodd\"><path d=\"M0 0v16h16V0H0zm12.031 2l.501-1H15v14H1V1h2.485l.484 1h8.062z\" /><path d=\"M3 5h2V4H3v1zM2 6h12V3H2v3zM3 9h2V8H3v1zm-1 1h12V7H2v3zM3 13h2v-1H3v1zm-1 1h12v-3H2v3z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id